import { ArrowBackIos, Logout, ManageAccounts, Translate } from "@mui/icons-material";
import { Alert, AlertColor, Button, Container, Grid, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider/useAuth";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { GetUser } from "../../services/UserServices";
import { LanguageRender } from "./components/LanguageRender/LanguageRender";
import { MyDataRender } from "./components/MyDataRender/MyDataRender";
import { RenderUserMenuOptions } from "./components/RenderUserMenuOptions";
import { SidebarUserMenuOptions } from "./components/SidebarUserMenu";

export interface IMyDataSidebarItem {
    id: number;
    text: string;
    icon: JSX.Element;
    onClick: (e?: any) => void;
}

export const MyData = () => {

    const [selectedOption, setSelectedOption] = useState<number>(1);
    const auth = useAuth();
    const { t } = useTranslation();
    const { id: idUser, setUserphone, setUsername } = useProfile();
    const navigate = useNavigate();
    const { nameOrg } = useParams();
    const [popupOk, setPopupOk] = useState<boolean>(false);
    const [alertColor, setAlertColor] = useState<AlertColor>("success");
    const [message, setMessage] = useState<string>("");
    const [index, setIndex] = useState<number>(1);

    function closePopUpOk() {
        setPopupOk(false);
    }

    useEffect(() => {
        GetUser(idUser!)
            .then(data => {
                setUserphone(data?.phone!);
                setUsername(data?.name!);
            })
            .catch(() => {
                setAlertColor("error");
                setMessage("Não foi possivel recuperar dados de usuário. Tente novamente.");
                navigate(`/${nameOrg}`);
            })
            .finally(() => {
                setAlertColor("success");
            })
    }, [])

    const logout = (event: any) => {
        event.preventDefault();

        auth.logout();
        window.history.replaceState(null, '', '/login');
        if (!auth.token) {
            return <Navigate to="/login" replace />;
        }
        return true;
    };

    const sideBarOptionList: IMyDataSidebarItem[] = [
        {
            id: 1,
            text: t("MyData.Mydata"),
            icon: <ManageAccounts sx={{ marginRight: "8px" }} />,
            onClick: () => {
                setSelectedOption(1)
            }
        },
        {
            id: 2,
            text: t("MyData.Language"),
            icon: <Translate sx={{ marginRight: "8px" }} />,
            onClick: () => {
                setSelectedOption(2)
            }
        },
        {
            id: 3,
            text: t("MyData.Logout"),
            icon: <Logout sx={{ marginRight: "8px" }} />,
            onClick: (e) => {
                logout(e)
            }
        },
    ];

    function renderMenuOptionSetter() {
        switch (selectedOption) {
            case 1:
                return <RenderUserMenuOptions
                    MenuOptionComponent={MyDataRender}
                    setAlertColor={setAlertColor}
                    setMessage={setMessage}
                    setPopupOk={setPopupOk}
                    index={index}
                />
            case 2:
                return <RenderUserMenuOptions
                    MenuOptionComponent={LanguageRender}
                    setAlertColor={setAlertColor}
                    setMessage={setMessage}
                    setPopupOk={setPopupOk}
                    index={index}
                />
        }
    }

    return (
        <>
            <Container
                style={{
                    border: "1px solid #e8e8e8",
                    borderRadius: "4px",
                    display: "flex",
                    flexDirection: "column",
                    padding: "30px",
                    maxWidth: "97%",
                    margin: "0 30px"
                }}
            >
                <div style={{ marginBottom: "10px" }}>
                    <Button
                        component="label"
                        role={undefined}
                        startIcon={<ArrowBackIos />}
                        style={{
                            color: "#22638D",
                            textTransform: "initial"
                        }}
                        onClick={()=>{navigate(-1)}}
                    >
                        Voltar
                    </Button>
                </div>
                <Grid container width="100%" height="100%" spacing={2} marginTop="0">
                    <SidebarUserMenuOptions
                        selectedOption={selectedOption}
                        sideBarOptionList={sideBarOptionList}
                        setIndex={setIndex}
                    />
                    {renderMenuOptionSetter()}
                </Grid>
                <Snackbar
                    open={popupOk}
                    autoHideDuration={6000}
                    message="Archived"
                    onClose={closePopUpOk}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    sx={{ bottom: { xs: 50, sm: 20 } }}
                >
                    <Alert elevation={6} variant="filled" sx={{ width: '100%' }} severity={alertColor} onClose={() => closePopUpOk()}>
                        {message}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}